import { render, staticRenderFns } from "./LightsHeadboard.vue?vue&type=template&id=e804c644"
import script from "./LightsHeadboard.vue?vue&type=script&lang=js"
export * from "./LightsHeadboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports